import Utils from '../../Utils';
import Analytics from './Analytics';
import LocalStorage from '../../LocalStorage';

export default class Popin {

    static initializeEvents() {
        const popin = document.querySelector('.popin');
        if (popin) {
            const popinKey = 'without_popin_' + popin.dataset.contentId;
            if (LocalStorage.getWithExpiry(popinKey) === 'on') {
                return;
            }

            Analytics.push('Popin', 'Affichage');

            const updatePopinHandler = Utils.throttle(this.updatePopinHandler, 20);

            const closeButton = popin.querySelector('.popin-close-button');
            if (closeButton) {
                closeButton.addEventListener('click', event => {
                    LocalStorage.setWithExpiry(popinKey, 'on', Utils.daysToMilliseconds(7));

                    window.removeEventListener('scroll', updatePopinHandler);
                    window.removeEventListener('resize', updatePopinHandler);

                    Analytics.push('Popin', 'Fermeture');

                    const currentPopin = Utils.parent(event.currentTarget, '.popin');
                    currentPopin.parentNode.removeChild(currentPopin);
                });
            }

            Array
                .from(popin.querySelectorAll('a.btn'))
                .forEach(button => button.addEventListener('click', event => {
                    Analytics.push('Popin', 'Clic sur un bouton', event.currentTarget.innerText);
                }));

            updatePopinHandler();
            window.addEventListener('scroll', updatePopinHandler);
            window.addEventListener('resize', updatePopinHandler);
        }
    }

    static updatePopinHandler() {
        const popin = document.querySelector('.popin');
        const windowHeight = document.body.scrollHeight;
        const windowScroll = window.scrollY;
        const scrollPercent = (windowScroll * 100) / windowHeight;

        if (scrollPercent >= 25 && scrollPercent < 60 && !popin.classList.contains('active')) {
            popin.classList.add('active');
        } else if ((scrollPercent < 25 || scrollPercent >= 60) && popin.classList.contains('active')) {
            popin.classList.remove('active');
        }
    }

}